export default __webpack_public_path__ + "static/media/orbits-loader.461e5db0.gif";